import { FC } from "react";
import { capitalize } from "~/utils";
import { VesselStatus } from "~/utils/constants";

type Props = { status: VesselStatus };

export const StatusBadge: FC<Props> = ({ status }) => {
  let bgColor, textColor;

  switch (status) {
    case VesselStatus.AVAILABLE:
      bgColor = "bg-green-100";
      textColor = "text-green-800";
      break;
    case VesselStatus.IN_USE:
      bgColor = "bg-blue-100";
      textColor = "text-blue-800";
      break;
    case VesselStatus.MAINTENANCE:
      bgColor = "bg-yellow-100";
      textColor = "text-yellow-800";
      break;
    default:
      bgColor = "bg-gray-100";
      textColor = "text-gray-800";
  }

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium ${bgColor} ${textColor}`}
    >
      {status ? capitalize(status) : "Unknown"}
    </span>
  );
};
